module.exports = __webpack_public_path__ + "static/img/poster5.f944ce0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poster5.jpg
// module id = 2jsU
// module chunks = 1